<template>
    <div class="g-list-item">
        <div class="g-item-avatar-wrap">
            <slot name="avatar"></slot>
        </div>
        <div class="g-item-content-wrap">
            <slot name="content"></slot>
        </div>
        <div class="g-item-aside-wrap">
            <slot name="aside"></slot>
        </div>
    </div>
</template>

<style>
    .g-list-item {
        display: flex;
        border: 1px solid var(--line);
        border-radius: 12px;
        padding: 10px 20px;
        margin-bottom: 20px;
        min-height: 64px;
    }
    .g-item-avatar-wrap {
        flex: 0 0 auto;
        align-items: center;
    }    
    .g-item-content-wrap {
        flex-grow: 1;
        padding: 0 20px;
    }
    .g-item-aside-wrap {
        flex: 0 0 auto;
    }    
</style>